import { FETCH_ACTIVATION_RATIO_DATA, SET_ACTIVATION_RATIO_DATA } from "./actionTypes/activationRatioTypes";

export const fetchActivationRatio = () => ({ type: FETCH_ACTIVATION_RATIO_DATA });
export const setActivationRatio = (data: any) => ({ type: SET_ACTIVATION_RATIO_DATA, payload: data });
